import React, {Component} from 'react';
import {connect} from 'react-redux';
import dataAPI from '../../_Utilities/DataAPI';
import {Helmet} from 'react-helmet';

import Image from '../../components/Image';
import ProjectsCarousel from '../../components/Carousels/ProjectsCarousel';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import './styles/GraduateModal.css';

class GraduateModal extends Component {
    title(name) {
        let path = window.location.pathname;

        if (path.includes('/graduates/')) {
            return `${name} • Graduates • D18`;
        } else if (path.includes('/team/')) {
            return `${name} • Team • D18`;
        } else if (path.includes('/projects/')) {
            return `${name} • Projects • D18`;
        } else {
            return `${name} • D18`;
        }
    }

    render() {
        // Get data from the object store
        const graduate = dataAPI.findOneByKey(this.props.graduates)('unikey', this.props.match.params.unikey);
        const projects = dataAPI.findAllByKey(this.props.projects)('key', graduate.projects);
        const img = graduate.image.full ? graduate.image.full : graduate.image.placeholder;

        return (
            <div className={'container'}>
                <Helmet>
                    <title>{this.title(graduate.fullName)}</title>
                </Helmet>
                <div className={'grid grid--modal'}>
                    <div className={'col--5'}>
                        <Image className={'modal__image'} src={img} cover/>
                    </div>
                    <div className={'col--7'}>
                        <div className={'modal__content content'}>
                            <div className={'content__section'}>
                                <div className={'sub-category text--pink uppercase'}>
                                    {graduate.roles[0] ? graduate.roles.join(' | ') : ''}
                                </div>
                                <h2 className=''>
                                    {graduate.fullName}
                                </h2>
                                <div className={'content__links'}>
                                    {graduate.links.map((link, i) => {
                                        return (
                                            <div className={'content__link'} key={i}>
                                                <a href={`${link.href}`} className={'link'} target={'_blank'}>
                                                    <FontAwesomeIcon className={'icon icon--small'} icon={link.icon}/>
                                                    {link.displayLink}
                                                </a>
                                            </div>
                                        )
                                    })}
                                </div>
                                <div className={'content__section'}>
                                    {graduate.bio}
                                </div>
                                <div className={'content__section'}>
                                    <ProjectsCarousel projects={projects}/>
                                </div>
                                <div className={'modal__close-spacer'}/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'modal__close'}>
                    <div className={'modal__close-button'} onClick={this.props.closeModal}>
                        <FontAwesomeIcon className={'icon'} icon={'times'}/>
                    </div>
                </div>
            </div>
        )
    }
}

const MapStateToProps = (state) => ({
    graduates: state.graduates,
    projects: state.projects,
});

export default connect(MapStateToProps)(GraduateModal);